import Alpine from '../../node_modules/alpinejs/dist/module.cjs';

window.Alpine = Alpine;

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== 'function') {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch((e) =>
                setTimeout(() => {
                    throw e;
                })
            );
    };
}

import './alpine-component/_downloads-page';
import './alpine-component/_interactive-map-with-accordion';

Alpine.start();
